import { IconName } from '@core/user-interface-legacy';

export enum AutomationTriggerType {
  CandidateMoved = 'candidate_moved',
  CandidateDisqualified = 'candidate_disqualified',
  CandidateOverdue = 'candidate_overdue',
  CandidateEvaluationStatusChanged = 'candidate_evaluation_status_changed',
  CandidateEventHasPassed = 'candidate_event_has_passed',
  CandidateEventScheduled = 'candidate_event_scheduled',
  CandidateEventRescheduled = 'candidate_event_rescheduled',
  CandidateEventDeleted = 'candidate_event_deleted',
  CandidateTagAdded = 'candidate_tag_added',
  CandidateNoteAdded = 'candidate_note_added',
  CandidateMarkedAsHired = 'candidate_marked_as_hired',
  CandidateTaskAdded = 'candidate_task_added',
  CandidateAllTasksCompleted = 'candidate_all_tasks_completed',
  CandidateRequalified = 'candidate_requalified',
  CandidateAssignedToThisJob = 'candidate_assigned_to_this_job',
  CandidateStageChanged = 'candidate_stage_changed',
  CandidateStartDateIs = 'candidate_start_date_is',
  JobNoteAdded = 'offer_note_added',
  JobStatusChanged = 'offer_status_changed',
  JobOpeningsFilled = 'offer_openings_filled',
  JobTagAdded = 'offer_tag_added',
  JobDateHasPassed = 'offer_date_has_passed',
}

export type AutomationTrigger = {
  type: AutomationTriggerType;
  name: string;
  iconName: IconName;
  data: AutomationTriggerData[] | null;
};

export type AutomationTriggerData = {
  name: string;
  value: AutomationTriggerDataValue;
  label?: string | string[];
};

export type AutomationTriggerDataValue = number | string | string[] | null;
export type AutomationConditionDataValue = number | string | string[] | null;

export enum TriggerCategory {
  Candidate = 'candidate',
  Job = 'offer',
}
